// チェッカー（英語式・8×8）のルール。ブラウザ（main.js / Worker）と Node（テスト・自動対戦）で共有する。
//
// 盤は濃い色の32マスだけを 0〜31 の番号で持つ（左上から右へ、上の段から順）。
//   段 r（0〜7）・列 c（0〜7）のうち (r+c) が奇数のマスが濃い色。番号 = r*4 + floor(c/2)。
//   黒は画面下（段 5〜7 ＝ 20〜31）から上へ、赤は画面上（段 0〜2 ＝ 0〜11）から下へ進む。黒が先手。
// 局面は 32bit の整数3本（黒の駒・赤の駒・キング）と手番で表す（AIの探索でそのまま使う）。
// 1手（move）は連続ジャンプをまとめた「完全な手」。path は通ったマス、caps は取った駒のマス。

(function (root, factory) {
    if (typeof module === 'object' && module.exports) module.exports = factory();
    else root.Checkers = factory();
})(typeof self !== 'undefined' ? self : this, function () {
    'use strict';

    const BLACK = 0;
    const RED = 1;
    const COLORS = ['black', 'red'];

    const SQ_ROW = new Int8Array(32);
    const SQ_COL = new Int8Array(32);
    for (let s = 0; s < 32; s++) {
        const r = s >> 2;
        SQ_ROW[s] = r;
        SQ_COL[s] = ((s & 3) << 1) + ((r + 1) & 1);
    }

    function squareAt(row, col) {
        if (row < 0 || row > 7 || col < 0 || col > 7 || ((row + col) & 1) === 0) return -1;
        return (row << 2) + (col >> 1);
    }

    // 隣のマス。方向は 0=左上 1=右上 2=左下 3=右下。盤の外は -1
    const NB = [];
    for (let s = 0; s < 32; s++) {
        const r = SQ_ROW[s], c = SQ_COL[s];
        NB.push([squareAt(r - 1, c - 1), squareAt(r - 1, c + 1), squareAt(r + 1, c - 1), squareAt(r + 1, c + 1)]);
    }
    const MAN_DIRS = [[0, 1], [2, 3]]; // 黒の通常駒は上へ、赤の通常駒は下へ
    const KING_DIRS = [0, 1, 2, 3];

    const INITIAL_RED = 0x00000FFF;   // 0〜11
    const INITIAL_BLACK = 0xFFF00000 | 0; // 20〜31

    // 引き分けの40手ルール：双方とも40手（80手番）続けて通常駒を動かさず、駒も取っていない
    const QUIET_PLY_LIMIT = 80;

    function bit(s) { return 1 << s; }
    function isPromotionSquare(side, s) { return side === BLACK ? s < 4 : s >= 28; }

    function popcount(x) {
        x = x - ((x >>> 1) & 0x55555555);
        x = (x & 0x33333333) + ((x >>> 2) & 0x33333333);
        return (Math.imul((x + (x >>> 4)) & 0x0F0F0F0F, 0x01010101) >>> 24);
    }

    // side の合法手を列挙する。
    // forceCapture=true : 取れる手があれば取る手（連続ジャンプは最後まで）だけ
    // forceCapture=false: 取る手（途中で止めるのも可）と普通の手の両方
    function generateMoves(b, r, k, side, forceCapture) {
        const own = side === BLACK ? b : r;
        const opp = side === BLACK ? r : b;
        const moves = [];

        for (let s = 0; s < 32; s++) {
            if (!(own & bit(s))) continue;
            const king = (k & bit(s)) !== 0;
            // 移動元は空けてから探す（ジャンプ中に元のマスへ戻れる）
            collectJumps(s, s, king, side, own & ~bit(s), opp, 0, [s], moves, !forceCapture);
        }
        if (moves.length > 0 && forceCapture) return moves;

        const occ = b | r;
        for (let s = 0; s < 32; s++) {
            if (!(own & bit(s))) continue;
            const king = (k & bit(s)) !== 0;
            const dirs = king ? KING_DIRS : MAN_DIRS[side];
            for (let i = 0; i < dirs.length; i++) {
                const to = NB[s][dirs[i]];
                if (to < 0 || (occ & bit(to))) continue;
                moves.push({
                    from: s, to, path: [s, to], caps: [], capMask: 0,
                    king, promote: !king && isPromotionSquare(side, to)
                });
            }
        }
        return moves;
    }

    // from の駒（今 cur にいる）からの連続ジャンプを深さ優先で集める。
    // captured は今回の手で既に跳んだ駒（同じ駒を2回は跳べない）。
    // partial=true なら途中で止める手も合法（取り強制なしのカジュアルルール）。
    function collectJumps(from, cur, king, side, own, opp, captured, path, out, partial) {
        const dirs = king ? KING_DIRS : MAN_DIRS[side];
        let extended = false;
        for (let i = 0; i < dirs.length; i++) {
            const mid = NB[cur][dirs[i]];
            if (mid < 0) continue;
            const land = NB[mid][dirs[i]];
            if (land < 0) continue;
            const mb = bit(mid);
            if (!(opp & mb) || (captured & mb) || ((own | opp) & bit(land))) continue;

            extended = true;
            const nextCaptured = captured | mb;
            path.push(land);
            // 通常駒は最奥の段に着いた時点でキングになり、その手は終わる
            const promote = !king && isPromotionSquare(side, land);
            let more = false;
            if (!promote) {
                more = collectJumps(from, land, king, side, own, opp, nextCaptured, path, out, partial);
            }
            if (!more || partial) {
                out.push({
                    from, to: land, path: path.slice(), caps: maskToSquares(nextCaptured),
                    capMask: nextCaptured, king, promote
                });
            }
            path.pop();
        }
        return extended;
    }

    function maskToSquares(mask) {
        const list = [];
        for (let s = 0; s < 32; s++) if (mask & bit(s)) list.push(s);
        return list;
    }

    // 手を適用した新しい局面を返す（元の局面は変えない）
    function applyMove(state, move) {
        const side = state.side;
        let b = state.b, r = state.r, k = state.k;
        const fromBit = bit(move.from), toBit = bit(move.to);
        const wasKing = (k & fromBit) !== 0;
        if (side === BLACK) { b = (b & ~fromBit) | toBit; r &= ~move.capMask; }
        else { r = (r & ~fromBit) | toBit; b &= ~move.capMask; }
        k &= ~move.capMask;
        if (wasKing) k = (k & ~fromBit) | toBit;
        else if (move.promote) k |= toBit;
        const quiet = (move.capMask !== 0 || !wasKing) ? 0 : state.quiet + 1;
        return { b, r, k, side: side ^ 1, quiet };
    }

    function positionKey(state) {
        return `${state.b >>> 0}.${state.r >>> 0}.${state.k >>> 0}.${state.side}`;
    }

    function initialState() {
        return { b: INITIAL_BLACK, r: INITIAL_RED, k: 0, side: BLACK, quiet: 0 };
    }

    // 標準の記譜（左上を1、右下を32とする番号）。跳びは x、普通の手は - で結ぶ
    function moveToNotation(move) {
        const sep = move.capMask ? 'x' : '-';
        return move.path.map(s => s + 1).join(sep);
    }

    // 何手読み（perft）：ルールの検証用。既知の値と一致するかをテストで見る
    function perft(state, depth, forceCapture = true) {
        if (depth === 0) return 1;
        const moves = generateMoves(state.b, state.r, state.k, state.side, forceCapture);
        if (depth === 1) return moves.length;
        let total = 0;
        for (const m of moves) total += perft(applyMove(state, m), depth - 1, forceCapture);
        return total;
    }

    class CheckersGame {
        constructor({ forceCapture = true } = {}) {
            this.forceCapture = forceCapture;
            this.reset();
        }

        reset() {
            this.history = [{ state: initialState(), move: null, result: null }];
            this.historyIndex = 0;
            this.selected = null;   // 選択中のマス
            this.jumpPath = null;   // 連続ジャンプを1跳びずつ入力しているときの途中経路
            this._legal = null;
        }

        get state() { return this.history[this.historyIndex].state; }
        get currentPlayer() { return COLORS[this.state.side]; }
        get side() { return this.state.side; }
        get lastMove() { return this.history[this.historyIndex].move; }
        get gameResult() { return this.history[this.historyIndex].result; }
        get gameOver() { return this.gameResult !== null; }
        get moveCount() { return this.historyIndex; }

        pieceAt(s) {
            const st = this.state;
            const m = bit(s);
            if (st.b & m) return { color: 'black', side: BLACK, king: (st.k & m) !== 0 };
            if (st.r & m) return { color: 'red', side: RED, king: (st.k & m) !== 0 };
            return null;
        }

        count(color) {
            const st = this.state;
            return popcount(color === 'black' ? st.b : st.r);
        }

        legalMoves() {
            if (this.gameOver) return [];
            if (!this._legal) {
                const st = this.state;
                this._legal = generateMoves(st.b, st.r, st.k, st.side, this.forceCapture);
            }
            return this._legal;
        }

        movesFrom(s) {
            return this.legalMoves().filter(m => m.from === s);
        }

        // 取らなければならない駒（取り強制のときだけ。ハイライト用）
        mustCaptureSquares() {
            if (!this.forceCapture) return [];
            const squares = [];
            for (const m of this.legalMoves()) {
                if (m.capMask && !squares.includes(m.from)) squares.push(m.from);
            }
            return squares;
        }

        makeMove(move) {
            if (this.gameOver) return false;
            const legal = this.legalMoves().find(m => sameMove(m, move));
            if (!legal) return false;
            const next = applyMove(this.state, legal);
            this.history.length = this.historyIndex + 1;
            this.history.push({ state: next, move: legal, result: null });
            this.historyIndex++;
            this._legal = null;
            this.selected = null;
            this.jumpPath = null;
            this.history[this.historyIndex].result = this.deriveResult();
            return true;
        }

        // 終局判定。動けない側の負け、同一局面3回・40手ルールは引き分け
        deriveResult() {
            const st = this.state;
            const moves = generateMoves(st.b, st.r, st.k, st.side, this.forceCapture);
            if (moves.length === 0) {
                return { type: 'win', winner: COLORS[st.side ^ 1], reason: popcount(st.side === BLACK ? st.b : st.r) === 0 ? 'noPieces' : 'noMoves' };
            }
            if (st.quiet >= QUIET_PLY_LIMIT) return { type: 'draw', winner: null, reason: 'fortyMove' };
            if (this.repetitionCount() >= 3) return { type: 'draw', winner: null, reason: 'threefold' };
            return null;
        }

        repetitionCount() {
            const key = positionKey(this.state);
            let n = 0;
            for (let i = this.historyIndex; i >= 0; i--) {
                if (positionKey(this.history[i].state) === key) n++;
            }
            return n;
        }

        canUndo() { return this.historyIndex > 0; }
        canRedo() { return this.historyIndex < this.history.length - 1; }

        undo(plies = 1) {
            if (!this.canUndo()) return false;
            this.historyIndex = Math.max(0, this.historyIndex - plies);
            this._legal = null; this.selected = null; this.jumpPath = null;
            return true;
        }

        redo(plies = 1) {
            if (!this.canRedo()) return false;
            this.historyIndex = Math.min(this.history.length - 1, this.historyIndex + plies);
            this._legal = null; this.selected = null; this.jumpPath = null;
            return true;
        }

        // 選択解除（ルール変更などで合法手を取り直すときにも使う）
        invalidate() { this._legal = null; this.selected = null; this.jumpPath = null; }

        setForceCapture(flag) {
            this.forceCapture = Boolean(flag);
            this.invalidate();
        }

        // 記譜（フィードバック用）。例: "11-15 23x14x7"
        movesNotation() {
            const out = [];
            for (let i = 1; i <= this.historyIndex; i++) out.push(moveToNotation(this.history[i].move));
            return out;
        }

        // 局面の文字列（PDN の FEN 風）。例: "B:W1,2,K5:B21,22"
        positionString() {
            const st = this.state;
            const list = side => {
                const own = side === BLACK ? st.b : st.r;
                const parts = [];
                for (let s = 0; s < 32; s++) if (own & bit(s)) parts.push(((st.k & bit(s)) ? 'K' : '') + (s + 1));
                return parts.join(',');
            };
            return `${st.side === BLACK ? 'B' : 'W'}:W${list(RED)}:B${list(BLACK)}`;
        }

        toJSON() {
            return {
                v: 1,
                forceCapture: this.forceCapture,
                historyIndex: this.historyIndex,
                history: this.history.map(h => ({
                    s: [h.state.b, h.state.r, h.state.k, h.state.side, h.state.quiet],
                    m: h.move ? { path: h.move.path, capMask: h.move.capMask } : null
                }))
            };
        }

        // 保存データから復元する。壊れていれば null（呼び出し側は新規対局にする）
        static fromJSON(data) {
            try {
                if (!data || data.v !== 1 || !Array.isArray(data.history) || data.history.length === 0) return null;
                const game = new CheckersGame({ forceCapture: data.forceCapture !== false });
                const first = data.history[0];
                if (!first || first.m !== null) return null;
                let state = stateFromArray(first.s);
                if (!state || positionKey(state) !== positionKey(initialState())) return null;
                game.history = [{ state, move: null, result: null }];
                for (let i = 1; i < data.history.length; i++) {
                    const h = data.history[i];
                    const legal = generateMoves(state.b, state.r, state.k, state.side, game.forceCapture);
                    const move = legal.find(m => h.m && m.capMask === h.m.capMask && samePath(m.path, h.m.path));
                    if (!move) return null;
                    state = applyMove(state, move);
                    const saved = stateFromArray(h.s);
                    if (!saved || positionKey(saved) !== positionKey(state)) return null;
                    game.history.push({ state, move, result: null });
                    game.historyIndex = i;
                    game.history[i].result = game.deriveResult();
                }
                const idx = Number(data.historyIndex);
                game.historyIndex = Number.isInteger(idx) ? Math.min(Math.max(idx, 0), game.history.length - 1) : game.history.length - 1;
                game._legal = null;
                return game;
            } catch (_) {
                return null;
            }
        }
    }

    function stateFromArray(a) {
        if (!Array.isArray(a) || a.length !== 5 || !a.every(n => Number.isInteger(n))) return null;
        return { b: a[0] | 0, r: a[1] | 0, k: a[2] | 0, side: a[3] ? RED : BLACK, quiet: a[4] };
    }

    function samePath(a, b) {
        return Array.isArray(b) && a.length === b.length && a.every((s, i) => s === b[i]);
    }

    function sameMove(a, b) {
        return a.from === b.from && a.to === b.to && a.capMask === (b.capMask | 0) && samePath(a.path, b.path);
    }

    return {
        BLACK, RED, COLORS, SQ_ROW, SQ_COL, NB, QUIET_PLY_LIMIT,
        squareAt, bit, popcount, isPromotionSquare,
        generateMoves, applyMove, positionKey, initialState, moveToNotation, perft,
        CheckersGame
    };
});
